import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer
} from 'recharts';
import dayjs from 'dayjs';

interface ChartData {
    timestamp: string;
    value: number;
}

interface FuelLevelChartProps {
    data: ChartData[];
    tooltipLabel?: string;
}

const FuelLevelChart = ({ data, tooltipLabel }: FuelLevelChartProps) => {
    const formattedData = data.map(item => ({
        ...item,
        timestamp: dayjs(item.timestamp).format('DD-MM-YYYY hh:MM'),
    }));

    return (
        <ResponsiveContainer width="100%" height={400}>
            <LineChart
                data={formattedData}
                margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="timestamp" tickFormatter={() => ''} />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line type="monotone" dataKey="value" stroke="#8884d8" activeDot={{ r: 8 }} name={tooltipLabel} />
            </LineChart>
        </ResponsiveContainer>
    );
};

export default FuelLevelChart;
